import { view } from "@risingstack/react-easy-state";

import { productImageUrl } from "../../common/imageUtils";
import type { Product } from "../../common/types/productTypes";
import ProductInfo from "./ProductInfo";

import { Interweave } from "interweave";
import { isEmpty } from "lodash-es";
import NutritionWrapper from "./NutritionWrapper";
import { AllergensDisplay } from "./ProductDetailsPage";

type ProductDetailsPrintProps = {
   product: Product;
};

const ProductDetailsPrint = ({ product }: ProductDetailsPrintProps) => {
   return (
      <div className="tw-hidden print:tw-block print:tw-grid print:tw-grid-cols-12 print:tw-gap-6 print:tw-pt-16">
         <div className="print:tw-col-span-9">
            <h1 className="print:tw-mb-1">{product.name}</h1>
            <div className="print:tw-mb-6">
               Art.nr.: {product.sku} {product.epdNumber ? <>| EPD: {product.epdNumber}</> : null}
            </div>
            <div>
               <p className="print:tw-mb-4">
                  <Interweave content={product.description?.toString()} />
               </p>
            </div>
         </div>
         <div className="print:tw-col-span-3 print:tw-items-center">
            <img
               className="print:tw-mx-auto print:tw-block print:tw-w-full"
               src={productImageUrl(product.sku, 380)}
               alt={`Produktbilde av ${product.name}`}
            />
         </div>

         <div className="print:tw-col-span-12">
            {!!product.ingredients && (
               <>
                  <h4>Ingredienser</h4>

                  <p className="print:tw-mb-6">
                     <Interweave content={product.ingredients.toString()} />
                  </p>
               </>
            )}

            {!isEmpty(product?.allergens) && (
               <>
                  <h4>Allergener</h4>

                  <p className="print:tw-mb-4">
                     <AllergensDisplay product={product} />
                  </p>
               </>
            )}
         </div>

         {product.nutritions && product.nutritions.length > 0 && (
            <div className="print:tw-col-span-6">
               <h4>Næringsinnhold</h4>

               <NutritionWrapper nutrition={product.nutritions} />
            </div>
         )}
         <div className="print:tw-col-span-6">
            <h4>Produktinformasjon</h4>

            <ProductInfo product={product} />
         </div>
      </div>
   );
};

export default view(ProductDetailsPrint);
